import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceiptPrintDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4417_790)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M52.0426 25.3772H46.8146C45.2609 25.3772 44 26.6382 44 28.1919C44 29.7477 45.2609 31.0064 46.8146 31.0064H50.0324C51.586 31.0064 52.8469 32.2673 52.8469 33.8231C52.8469 35.3768 51.586 36.6377 50.0324 36.6377H44.8043",
				stroke: "#8588D8",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.4235 36.6372V39M48.4235 23V25.3835",
				stroke: "#8588D8",
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.6592 46.5C69.9351 46.5002 70.1592 46.724 70.1592 47V47.3916H71.0156C71.2918 47.3916 71.5156 47.6155 71.5156 47.8916C71.5156 48.1677 71.2917 48.3916 71.0156 48.3916H69.6797C69.6729 48.3919 69.6661 48.3935 69.6592 48.3936C69.6524 48.3936 69.6454 48.3919 69.6387 48.3916H69.0557C68.7492 48.3916 68.5 48.6408 68.5 48.9473C68.5002 49.2542 68.749 49.5029 69.0557 49.5029H70.2617C71.1207 49.5029 71.8173 50.1994 71.8174 51.0586C71.8173 51.9173 71.1205 52.6143 70.2617 52.6143H70.1592V53C70.1592 53.276 69.9351 53.4998 69.6592 53.5C69.383 53.5 69.1592 53.2761 69.1592 53V52.6143H68.3018C68.0257 52.6143 67.8018 52.3903 67.8018 52.1143C67.8018 51.8381 68.0256 51.6143 68.3018 51.6143H70.2617C70.5682 51.6143 70.8173 51.365 70.8174 51.0586C70.8173 50.7512 70.5679 50.5029 70.2617 50.5029H69.0557C68.1972 50.5029 67.5002 49.8069 67.5 48.9473C67.5 48.0885 68.1969 47.3916 69.0557 47.3916H69.1592V47C69.1592 46.7239 69.383 46.5 69.6592 46.5Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.6592 56C69.9351 56.0002 70.1592 56.224 70.1592 56.5V56.8916H71.0156C71.2918 56.8916 71.5156 57.1155 71.5156 57.3916C71.5156 57.6677 71.2917 57.8916 71.0156 57.8916H69.6797C69.6729 57.8919 69.6661 57.8935 69.6592 57.8936C69.6524 57.8936 69.6454 57.8919 69.6387 57.8916H69.0557C68.7492 57.8916 68.5 58.1408 68.5 58.4473C68.5002 58.7542 68.749 59.0029 69.0557 59.0029H70.2617C71.1207 59.0029 71.8173 59.6994 71.8174 60.5586C71.8173 61.4173 71.1205 62.1143 70.2617 62.1143H70.1592V62.5C70.1592 62.776 69.9351 62.9998 69.6592 63C69.383 63 69.1592 62.7761 69.1592 62.5V62.1143H68.3018C68.0257 62.1143 67.8018 61.8903 67.8018 61.6143C67.8018 61.3381 68.0256 61.1143 68.3018 61.1143H70.2617C70.5682 61.1143 70.8173 60.865 70.8174 60.5586C70.8173 60.2512 70.5679 60.0029 70.2617 60.0029H69.0557C68.1972 60.0029 67.5002 59.3069 67.5 58.4473C67.5 57.5885 68.1969 56.8916 69.0557 56.8916H69.1592V56.5C69.1592 56.2239 69.383 56 69.6592 56Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M69.6592 76C69.9351 76.0002 70.1592 76.224 70.1592 76.5V76.8916H71.0156C71.2918 76.8916 71.5156 77.1155 71.5156 77.3916C71.5156 77.6677 71.2917 77.8916 71.0156 77.8916H69.6797C69.6729 77.8919 69.6661 77.8935 69.6592 77.8936C69.6524 77.8936 69.6454 77.8919 69.6387 77.8916H69.0557C68.7492 77.8916 68.5 78.1408 68.5 78.4473C68.5002 78.7542 68.749 79.0029 69.0557 79.0029H70.2617C71.1207 79.0029 71.8173 79.6994 71.8174 80.5586C71.8173 81.4173 71.1205 82.1143 70.2617 82.1143H70.1592V82.5C70.1592 82.776 69.9351 82.9998 69.6592 83C69.383 83 69.1592 82.7761 69.1592 82.5V82.1143H68.3018C68.0257 82.1143 67.8018 81.8903 67.8018 81.6143C67.8018 81.3381 68.0256 81.1143 68.3018 81.1143H70.2617C70.5682 81.1143 70.8173 80.865 70.8174 80.5586C70.8173 80.2512 70.5679 80.0029 70.2617 80.0029H69.0557C68.1972 80.0029 67.5002 79.3069 67.5 78.4473C67.5 77.5885 68.1969 76.8916 69.0557 76.8916H69.1592V76.5C69.1592 76.2239 69.383 76 69.6592 76Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M80.5 86.3232C80.5028 88.5927 79.4283 90.4955 77.8643 91.584C76.2962 92.6752 74.2367 92.9431 72.333 91.9365L69.0801 90.2139C67.2592 89.2521 65.1557 89.1838 63.29 90.0234L63.291 90.0244L54.0303 94.1943C50.1676 95.935 45.8384 95.9348 41.9707 94.1943H41.9697L32.7305 90.0293H32.7295C30.8584 89.1842 28.7607 89.253 26.9404 90.2148L23.6621 91.9473L23.6611 91.9482C21.7601 92.9515 19.702 92.6839 18.1348 91.5928C16.6689 90.5722 15.6331 88.8355 15.5117 86.75L15.5 86.3291L15.54 12H16.54L16.5 86.3301C16.4976 88.2791 17.4155 89.8728 18.7061 90.7715C19.993 91.6675 21.6518 91.8776 23.1943 91.0635L26.4736 89.3301C28.5654 88.2249 30.9874 88.145 33.1416 89.1182L42.3799 93.2822C45.9868 94.9053 50.0179 94.906 53.6191 93.2832L62.8799 89.1123L63.2861 88.9434C65.1945 88.2117 67.2864 88.28 69.1514 89.1348L69.5479 89.3301L72.8008 91.0527C74.3459 91.8698 76.0055 91.6595 77.293 90.7637C78.5843 89.865 79.5023 88.2712 79.5 86.3252V12H80.5V86.3232Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M25.1431 80.64C24.7722 78.7763 25.5917 75.6592 31.8366 78.1007C39.6427 81.1527 28.066 81.8469 30.1657 80.49C32.2655 79.1331 37.3231 78.4843 42.2411 79.8305",
				stroke: "white",
				strokeOpacity: .16,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4 1C2.34315 1 1 2.34315 1 4V12C1 13.1046 2.34315 14 4 14H15.5V16H4C1.79086 16 0 14.2091 0 12V4C0 1.79086 1.79086 6.44256e-08 4 0H92C94.2091 1.03081e-06 96 1.79086 96 4V12C96 14.2091 94.2091 16 92 16H80.5V14H92C93.6569 14 95 13.1046 95 12V4C95 2.34315 93.6569 1 92 1H4Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M82 8C83.1046 8 84 8.89543 84 10C84 11.1046 83.1046 12 82 12H79.5V10H16.5V12H14C12.8954 12 12 11.1046 12 10C12 8.89543 12.8954 8 14 8H82Z",
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 79,
				y: 4,
				width: 3,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 77,
				y: 4,
				width: 1,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 75,
				y: 4,
				width: 1,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 73,
				y: 4,
				width: 1,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 12,
				y: 4,
				width: 1,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 14,
				y: 4,
				width: 1,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 50,
				width: 27,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 24,
				y: 59,
				width: 21,
				height: 1,
				rx: .5,
				fill: "white",
				fillOpacity: .16
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16.5 70H79.5",
				stroke: "white",
				strokeOpacity: .16,
				strokeDasharray: "4 4"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 20,
				y: 14,
				width: 2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 23,
				y: 14,
				width: .5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 24.5,
				y: 14,
				width: 1,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 26.5,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 27.7,
				y: 14,
				width: 1.5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 30.2,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 31.4,
				y: 14,
				width: .5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 32.9,
				y: 14,
				width: 2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 35.9,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 37.1,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 38.3,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 57,
				y: 14,
				width: 2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 60,
				y: 14,
				width: .5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 61.5,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 62.7,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 63.9,
				y: 14,
				width: 1,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 65.9,
				y: 14,
				width: .5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 67.4,
				y: 14,
				width: 1.5,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 69.9,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 71.1,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 72.3,
				y: 14,
				width: 2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 75.3,
				y: 14,
				width: .2,
				height: 3,
				fill: "white",
				fillOpacity: .24
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4417_790",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgReceiptPrintDark;
